module.exports = __webpack_public_path__ + "1793882494189/images/Flaticon.0098bbc.svg";